import axios from "axios";
import { BASE_URL } from "../utils/EmpUtil";

export default class DeliveryClient {
  static baseUrl = BASE_URL;

  static getPreDeliveryTasks(paCode, dealerCommonId) {
    const encodedPaCode = encodeURIComponent(paCode);
    let url = `${this.baseUrl}/dealer/predelivery-tasks?paCode=${encodedPaCode}`;

    if (dealerCommonId) {
      url += `&dealerCommonId=${encodeURIComponent(dealerCommonId)}`;
    }

    return axios.get(url);
  }

  static addPreDeliveryTask(paCode, payload, dealerCommonId) {
    const encodedPaCode = encodeURIComponent(paCode);
    let url = `${this.baseUrl}/dealer/predelivery-tasks/save?paCode=${encodedPaCode}`;

    if (dealerCommonId) {
      url += `&dealerCommonId=${encodeURIComponent(dealerCommonId)}`;
    }

    const { taskName, taskDescription, taskUrl, vehicleType, brandCode } =
      payload;

    return axios.post(url, {
      paCode,
      taskName,
      taskDescription,
      taskUrl,
      vehicleType,
      brandCode,
    });
  }

  static updatePreDeliveryTask(paCode, payload, dealerCommonId) {
    const encodedPaCode = encodeURIComponent(paCode);
    let url = `${this.baseUrl}/dealer/predelivery-tasks/update?paCode=${encodedPaCode}`;

    if (dealerCommonId) {
      url += `&dealerCommonId=${encodeURIComponent(dealerCommonId)}`;
    }

    const { id, taskName, taskDescription, taskUrl, vehicleType, brandCode } =
      payload;

    return axios.put(url, {
      id,
      paCode,
      taskName,
      taskDescription,
      taskUrl,
      vehicleType,
      brandCode,
    });
  }

  static removePreDeliveryTask(paCode, { id }, dealerCommonId) {
    const encodedPaCode = encodeURIComponent(paCode);
    let url = `${this.baseUrl}/dealer/predelivery-tasks/delete/${id}?paCode=${encodedPaCode}`;

    if (dealerCommonId) {
      url += `&dealerCommonId=${encodeURIComponent(dealerCommonId)}`;
    }

    return axios.delete(url);
  }
}
